import { useCallback, useMemo } from 'react';
import MenuOption from '~/constants/MenuOption';
import { useFacetData } from '~/contexts/FacetDataContext';
import Make from './Make';
import FilterDrawer from '../FilterDrawer';
import { CommonWrapper } from '../styles';
import useExpand from '../useExpand';
import WithClassName from '../WithClassName';
import WithExpandOnOpen from '../WithExpandOnOpen';

type OwnProps = WithClassName & WithExpandOnOpen;

export default function MakeModel({ className, expandOnOpen }: OwnProps) {
  const facetData = useFacetData();
  const makes = useMemo(
    () => Object.values(facetData.makes ?? {}),
    [facetData.makes]
  );
  const expandSection = expandOnOpen === MenuOption.Make;
  const [show, setShow] = useExpand(expandSection);

  return (
    <FilterDrawer
      className={className}
      dataQa="facet-make-model"
      facetContent={makes}
      facetName="Make & Model"
      show={show}
      onToggle={useCallback(() => setShow(v => !v), [setShow])}
      expandOnOpen={expandSection}
    >
      <CommonWrapper>
        {makes.map(make => (
          <Make {...make} key={make.key} make={make.key} />
        ))}
      </CommonWrapper>
    </FilterDrawer>
  );
}
